import React from 'react';

import { ColumntLayoutProps } from '../ContentSection';

import './left-side-dominant-two-columns-layout.scss';

export const LeftSideDominantTwoColumnsLayout: React.FC<ColumntLayoutProps> = ({ content, renderWidget }) => (
  <div className="student-left-side-dominant-two-columns-layout">
    <div className="student-column student-left-side-dominant-two-columns-layout__column student-left-side-dominant-two-columns-layout__column--left">
      {renderWidget(content.columns[0].widget)}
    </div>
    <div className="student-column student-left-side-dominant-two-columns-layout__column student-left-side-dominant-two-columns-layout__column--right">
      {renderWidget(content.columns[1].widget)}
    </div>
  </div>
);
